import { render, staticRenderFns } from "./coupons_list.vue?vue&type=template&id=15537d5c&scoped=true&"
import script from "./coupons_list.vue?vue&type=script&lang=js&"
export * from "./coupons_list.vue?vue&type=script&lang=js&"
import style0 from "./coupons_list.vue?vue&type=style&index=0&id=15537d5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15537d5c",
  null
  
)

export default component.exports